import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RANK_TIERS } from './constants';
import RankShield from './RankShield';

const RankLegend = () => {
  const { t } = useTranslation();
  const [showLegend, setShowLegend] = useState(false);

  return (
    <div className="rank-legend-container">
      <button
        className="rank-legend-button"
        onClick={() => setShowLegend(!showLegend)}
        title={t('elo.ranksAria')}
      >
        🏅 {t('elo.ranksBtn')}
      </button>
      {showLegend && (
        <div className="rank-legend-modal">
          <div className="rank-legend-content">
            <button className="close-button" onClick={() => setShowLegend(false)}>×</button>
            <h3>🏅 {t('elo.rankingSystem')}</h3>
            <p className="rank-legend-description">
              {t('elo.rankingDesc')}
            </p>
            <div className="rank-tiers-list">
              {RANK_TIERS.map(tier => (
                <div key={tier.name} className="rank-tier-item" style={{ borderLeftColor: tier.color }}>
                  <RankShield tier={tier} size={28} />
                  <span className="rank-tier-name" style={{ color: tier.color }}>{tier.name}</span>
                  <span className="rank-tier-range">{tier.minElo}+</span>
                </div>
              ))}
            </div>
            <div className="rank-legend-info">
              <h4>{t('elo.howItWorks')}</h4>
              <ul>
                <li>{t('elo.startingElo')} <strong>1000</strong></li>
                <li>{t('elo.rankedAfter')} <strong>{t('elo.fiveMatches')}</strong></li>
                <li>{t('elo.formula')}</li>
                <li>{t('elo.kfactor')}</li>
              </ul>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RankLegend;
